import React from "react"
import { Router } from "@reach/router"
import Layout from "../components/layout"
import Profile from "../components/profile"
import Login from "../components/login"
import PrivateRoute from "../components/privateRoute"
import Logout from "../components/logout"
const App = () => (
  <Layout>
    <Router>
      <PrivateRoute path="/app/" component={Profile} />
      <Login path="/app/login" />
      <Logout path="/app/logout" />
    </Router>
  </Layout>
)
export default App
